// extracted by mini-css-extract-plugin
export var closeButton = "_f8-1";
export var closeX = "_f8-3";
export var container = "_f8-0";
export var image = "_f8-2";